import { init as initVehicleDetails }
    from '../../../_views/vehicle_details/vehicle_details';
import CheckoutContainersConstants from './checkout_container_constants';

/**
 * @param {string} productType
 */
function initializeCommonPageModules(productType) {
    const staticUrl = TYROOLA.globals.staticUrl;
    const isMobile = $(window).width() < 768;
    let isValidConfigurator = false;
    /**
     *
     * initialize initially visible components first
     *
     */
    const vehicleDetailsContainer = document.querySelectorAll(`#${CheckoutContainersConstants.VEHICLE_DETAILS_CONTAINER_ID}`);

    if (vehicleDetailsContainer) {
        vehicleDetailsContainer.forEach(container => {
            isValidConfigurator = container.parentElement.parentElement.classList.contains('visible-xs');
            if ((isMobile && isValidConfigurator) || (!isMobile)) {
                const vehicleDetailsOptions = { productType, staticUrl };
                initVehicleDetails(container, vehicleDetailsOptions);
            }
        });
    }
}

export { initializeCommonPageModules };
